import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  Input,
  inject,
} from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ProjectWatchService } from '../../shared/services/project-watch/project-watch.service';

@Component({
  selector: 'app-project-watch',
  templateUrl: './project-watch.component.html',
  styleUrls: ['./project-watch.component.scss'],
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatTooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectWatchComponent implements OnInit, OnDestroy, OnChanges {
  @Input() projectId!: number;

  private readonly projectWatchService = inject(ProjectWatchService);
  readonly isWatching = this.projectWatchService.isWatching;

  ngOnInit(): void {
    if (this.projectId) {
      this.projectWatchService.initialize(this.projectId);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['projectId'] &&
      !changes['projectId'].firstChange &&
      this.projectId
    ) {
      this.projectWatchService.cleanup();
      this.projectWatchService.initialize(this.projectId);
    }
  }

  ngOnDestroy(): void {
    this.projectWatchService.cleanup();
  }

  toggleWatch(): void {
    this.projectWatchService.toggleWatch(this.projectId);
  }
}
